import { useMemo } from 'react'

import { useProductPageUrlParams } from '../../hooks'
import { environment } from '../../../../core/components'

export const useSelectedSkuLowResolutionImages = () => {
  const { selectedSkuId } = useProductPageUrlParams()

  // TODO: try use some relay-runtime util to build cache links
  const image = useMemo(() => {
    const store = environment.getStore().getSource()
    const skuCache = store.get(selectedSkuId) as any
    const skuImagesCache = store.get(skuCache?.images?.__ref) as any

    const skuImagesEdgesCache =
      skuImagesCache?.edges.__refs.map((ref: any) => store.get(ref)) ?? []

    const skuImages = skuImagesEdgesCache.map((edge: any) => {
      const skuImageCache = store.get(edge?.node?.__ref)

      return skuImageCache?.['url(size:420)'] ?? ''
    })

    return skuImages
  }, [selectedSkuId])

  return image as string[]
}
